import { render, staticRenderFns } from "./ItemFilterAuctionExhibitLayout.vue?vue&type=template&id=4bdcba2a&scoped=true"
import script from "./ItemFilterAuctionExhibitLayout.vue?vue&type=script&lang=js"
export * from "./ItemFilterAuctionExhibitLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdcba2a",
  null
  
)

export default component.exports